var map = {
	"./gs/NewUi": 938,
	"./gs/NewUi.js": 938,
	"./gs/OldUi": 939,
	"./gs/OldUi.js": 939,
	"./spireon/SpireonNew": 940,
	"./spireon/SpireonNew.js": 940,
	"./spireon/SpireonOld": 941,
	"./spireon/SpireonOld.js": 941
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2719;